import { useQuery } from "@tanstack/react-query";
import { ActivitiesResponse, fetchActivities } from "PFCore/services/activities";
import { QueryOptions, QueryParams } from "PFTypes";

import { activitiesKeys } from "./query_keys";

export const useActivities = <TData = ActivitiesResponse>(
  params: QueryParams,
  options: QueryOptions<ActivitiesResponse, unknown, TData> = {}
) =>
  useQuery<ActivitiesResponse, unknown, TData>({
    queryKey: activitiesKeys.all(params),
    queryFn: () => fetchActivities(params),
    ...options
  });
